export default "__VITE_ASSET__f5490947__"